module.exports = __webpack_public_path__ + "img/lv21.01c2cee9.png";